import React from 'react';
import { Box, IconButton, Tooltip } from '@mui/material';
import { Menu as MenuIcon, Add as AddIcon, ChevronLeft as ChevronLeftIcon } from '@mui/icons-material';
import styled from 'styled-components';
import { colors } from '../theme';
import ChatHistory from './ChatHistory';
import MessageInput from './MessageInput';

const ChatContainer = styled(Box)`
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  height: 100vh;
  background-color: ${colors.background};
  margin-left: 0;
  width: 100%;
  min-width: 0;
`;

const ChatHeader = styled(Box)`
  background: ${colors.background};
  padding: ${props => props.$isMobile ? '8px 12px' : '12px 20px'};
  min-height: ${props => props.$isMobile ? '56px' : '60px'};
  display: flex;
  border: 0;
  align-items: center;
  position: sticky;
  top: 0;
  z-index: 100;
  gap: ${props => props.$isMobile ? '8px' : '0'};
  border-bottom: 1px solid rgba(0,0,0,0.04);
`;

const ChatContent = styled(Box)`
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  min-height: 0;
`;

const HeaderButton = styled(IconButton)`
  && {
    color: ${colors.gray[500]};
    background: transparent;
    padding: 8px;
    flex-shrink: 0;
    border-radius: 10px;
    transition: all 0.2s ease;
    
    &:hover {
      background: rgba(228, 116, 112, 0.08);
      color: ${colors.primary};
      transform: scale(1.05);
    }
  }
`;

const NewChatButton = styled(IconButton)`
  && {
    color: ${colors.gray[500]};
    background: transparent;
    padding: 8px;
    flex-shrink: 0;
    border-radius: 10px;
    transition: all 0.2s ease;
    
    &:hover {
      color: ${colors.primary};
      background: rgba(228, 116, 112, 0.08);
      transform: scale(1.05);
    }
  }
`;

const ChatArea = ({ 
  messages, 
  onSendMessage, 
  currentConversation,
  isStreaming,
  sidebarCollapsed = false,
  isMobile = false,
  onOpenSidebar,
  onToggleSidebar,
  onNewChat,
}) => {
  return (
    <ChatContainer $sidebarCollapsed={sidebarCollapsed}>
      {/* 聊天头部 */}
      <ChatHeader $isMobile={isMobile}>
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', backgroundColor: 'transparent', width: '100%', gap: 1 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', backgroundColor: 'transparent', flex: 1, minWidth: 0, gap: 0.5 }}>
            <Tooltip title={isMobile ? "打开菜单" : (sidebarCollapsed ? "展开侧边栏" : "收起侧边栏")} placement="bottom">
              <HeaderButton onClick={isMobile ? onOpenSidebar : onToggleSidebar} size="large">
                <MenuIcon />
              </HeaderButton>
            </Tooltip>
            <h2 style={{ 
              margin: 0, 
              color: colors.text.primary, 
              fontSize: isMobile ? '1.1rem' : '1.2rem',
              fontWeight: 600,
              backgroundColor: 'transparent',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap'
            }}>
              {currentConversation?.title || '新对话'}
            </h2>
          </Box>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
            <Tooltip title="新建对话" placement="bottom">
              <NewChatButton onClick={onNewChat} size="large">
                <AddIcon />
              </NewChatButton>
            </Tooltip>
          </Box>
        </Box>
      </ChatHeader>

      {/* 聊天内容区域 */}
      <ChatContent>
        <ChatHistory 
          messages={messages} 
          streamingMessage={isStreaming && messages.length > 0 && !messages[messages.length - 1].isUser && !messages[messages.length - 1].isSynced ? messages[messages.length - 1].content : ''}
          isStreaming={isStreaming}
          isMobile={isMobile}
        />
        <MessageInput 
          onSendMessage={onSendMessage}
          disabled={isStreaming}
          isMobile={isMobile}
        />
      </ChatContent>
    </ChatContainer>
  );
};

export default ChatArea;
